export default __webpack_public_path__ + "static/media/roadmap-3.00b84592.svg";